import { AssessmentProfile } from '@/domain/models/profile-assessment/assessment-profile'
import { AssessmentCompetence } from '@/domain/models/profile-assessment/assessment-competence'

export type ScoreField = 'marketScore' | 'companyScore' | 'userScore'

export type Scores = {
  [key in ScoreField]: number
}

export type UserProfileAssessmentCompetenceModel = {
  competence: AssessmentCompetence.Enum
  marketDistance: number
} & Scores

export type UserProfileAssessmentModel = {
  url: string
  finished: boolean
  finishedAt: string | null
  expiresAt: string
  externalUniqueId: string
  profile: AssessmentProfile.Enum | null
  competences: UserProfileAssessmentCompetenceModel[] | null
}

export function isComplete(model?: UserProfileAssessmentModel | null): boolean {
  return !!model && model.competences != null && model.competences.length > 0 && model.finished
}

export function getSortedCompetences(model?: UserProfileAssessmentModel | null) {
  if (!isComplete(model)) {
    return []
  }
  return model!.competences!.sort((a, b) => b.marketDistance - a.marketDistance)
}

export function getStrengths(
  model?: UserProfileAssessmentModel | null
): UserProfileAssessmentCompetenceModel[] {
  return getSortedCompetences(model).slice(0, 4)
}

export function getWeakness(
  model?: UserProfileAssessmentModel | null
): UserProfileAssessmentCompetenceModel[] {
  return getSortedCompetences(model).slice(4, 6)
}
